/**
 * Grab the tokens generate from figma
 * */
import theme from './src/constants/theme.json'
import generateColorsSafelist from './scripts/generate-colors-safelist'
import {
    availablePrimaryColors,
    availablePrimaryHoverColors,
    availableSecondaryColors,
} from './src/dynamic-config/dynamic-colors'
import forms from '@tailwindcss/forms'

const { colors } = theme

const config = {
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    theme: {
        fontFamily: {
            artnetGrotesk: 'ArtnetGrotesk, sans-serif',
        },
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            purple: 'purple',
            ...colors,
        },
        // Note: we have to override the entire `screens` property instead of using
        // `extend:` because the `safelist` doesn't pick up on classes added using `extend`,
        // and our `standardImageSizeClasses` make use of custom screen sizes.
        screens: {
            '2xs': '481px', // anything larger than a standard phone in portrait mode

            // we need this for setting scrollbar settings differently on phones than other
            // viewports, to avoid needing the workaround described at
            // https://stackoverflow.com/a/72511916/560114
            '2xs-max': { max: '575px' },

            xs: '576px', // phone in landscape mode

            // begin default tailwind breakpoints
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1536px',
            // end default tailwind breakpoints
        },
        keyframes: {
            accordionSlideDown: {
                from: { height: 0, marginTop: 0 },
                to: {
                    height: 'var(--radix-accordion-content-height)',
                    marginTop: '1.5rem',
                },
            },
            accordionSlideUp: {
                from: {
                    height: 'var(--radix-accordion-content-height)',
                    marginTop: '1.5rem',
                },
                to: { height: 0, marginTop: 0 },
            },
        },
        animation: {
            accordionSlideDown:
                'accordionSlideDown 500ms cubic-bezier(0.87, 0, 0.13, 1)',
            accordionSlideUp:
                'accordionSlideUp 500ms cubic-bezier(0.87, 0, 0.13, 1)',
        },
    },
    plugins: [forms],
    safelist: [
        // TODO these will need to be moved to tailwind-safelist.md or some other file picked
        // up by tailwind when we upgrade to Tailwind 4.
        // This is because we built a dynamic theming feature...we didn't end up using multiple
        // themes as originally planned, but the Button component is currently depending on it.
        // The other alternative would be to remove `theme` from the LibraryConfig context
        // and update the Button component accordingly.
        ...generateColorsSafelist(availablePrimaryColors),
        ...generateColorsSafelist(availableSecondaryColors),
        ...generateColorsSafelist(availablePrimaryHoverColors),
    ],
}

export default config
